import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(data) {
        const items = data.cart_data.items;
        const resultItems = data.result;

        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.cart_preview-items');
          itensCartPreview.innerHTML = '';

          items.forEach((item, index) => {
            let brandHtml = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let sizeSelect = '';
            if (item.options && item.options.length > 0) {
              sizeSelect = `
                <label class="cart-item-content-size">
                  Tamanho:
                  <div class="select-content">
                    <select class="variation-select" data-original-id="${item.original_id}">
                      ${item.options.map(opt => `
                        <option 
                          value="${opt.product_id}" 
                          ${opt.product_id == item.original_id ? 'selected' : ''} 
                          ${!opt.available ? 'disabled' : ''}>
                            ${opt.value}
                        </option>
                      `).join('')}
                    </select>
                  </div>
                </label>
              `;
            }

            // ID correto que a API quer pra deletar (do result)
            const deleteId = resultItems[index]?.id;

            let itemHTML = `
              <li class="cart-item ${item.is_gift ? 'is-gift' : ''}" data-product-id="${item.id}">
                <figure>
                  <img src="${item.image_medium}" alt="${item.name}">
                </figure>
                <div class="cart-item-content">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                  <div class="group-content"> 
                    ${sizeSelect}
                    <div class="group-quantity">
                      <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                      <span class="qtd-value">${item.quantity}</span>
                      <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
                    </div>
                    <button class="delete-item-button" data-original-id="${deleteId}"></button>
                  </div>
                </div>
              </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
            el.textContent = String(data.result.length).padStart(2, '0');
          });

          document.querySelector('.total_value_cart_preview').textContent =
            new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);

          // Atualiza eventos dos botões
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });

          document.querySelectorAll('.btn-increase').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              
              updateItemQuantity(originalId, qtdAtual + 1);
            });
          });

          document.querySelectorAll('.btn-decrease').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              if (qtdAtual > 1) {
                updateItemQuantity(originalId, qtdAtual - 1);
              } else {
                deleteCartItem(originalId);
              }
            });
          });

          document.querySelectorAll('.variation-select').forEach(select => {
            select.addEventListener('change', function () {
              const selectedOption = this.options[this.selectedIndex];
              const newProductId = selectedOption.value;

              const cartItemEl = this.closest('.cart-item-content');
              const currentQty = parseInt(cartItemEl.querySelector('.qtd-value')?.textContent || 1, 10);
          
              const cartItem = this.closest('.cart-item');
              const itemId = cartItem.classList.contains('is-gift') ? cartItem?.querySelector('.delete-item-button')?.getAttribute('data-original-id') : cartItem?.getAttribute('data-product-id');
              const currentProductId = cartItem.querySelector('select')?.getAttribute('data-original-id');
          
              if (!itemId || !currentProductId || !newProductId) {
                console.error('IDs insuficientes para processar troca de variação.');
                return;
              }
          
              const payload = [{
                addon_values: "[]",
                as_free: false,
                is_buying_by_measure: false,
                item_id: itemId,
                product: currentProductId,
                new_product: newProductId,
                quantity: currentQty,
                replace_quantity: true
              }];
          
              $.ajax({
                type: 'POST',
                url: '/api/front/cart/items/?version=2',
                headers: { 'Content-Type': 'application/json' },
                dataType: 'json',
                data: JSON.stringify(payload)
              }).done(function (data) {
                if (data && data.cart_data && data.result) {
                  updateCartPreview(data);
                  select.setAttribute('data-original-id', newProductId);
                }
              }).fail(function (jqXHR, textStatus, errorThrown) {
                console.error('Erro ao trocar variação:', errorThrown);
                alert('Erro ao trocar o tamanho do produto.');
              });
            });
          });
        }
      }

      function deleteCartItem(id) {
        $.ajax({
          type: 'DELETE',
          url: '/api/front/cart/items/remove',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify([{ id: id }])
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            reloadCartPreview();
            updateCartPreview(data);
          }
        }).fail(function (err) {
          console.error('Erro ao remover item do carrinho:', err);
        });
      }

      function updateItemQuantity(originalId, newQty) {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        $.ajax({
          type: 'POST',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify(payload)
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          var data = jqXHR.responseJSON;
  
          if (Array.isArray(data) && data.length > 0 && data[0].stock) {
            alert(`O produto <b>"${data[0].stock.product.name}"</b> possui <b>${data[0].stock.quantity}</b> unidade[s] em estoque.`);
          } else {
            alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
          }
        
          console.error('Erro ao atualizar quantidade:', errorThrown);
        });
      }

      function reloadCartPreview() {
        $.ajax({
          type: 'GET',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json'
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);

            document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
              el.textContent = String(data.result.length).padStart(2, '0');
            });

            document.querySelector('.total_value_cart_preview').textContent =
              new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);
          }
        });
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.result) {
          console.log(data);
          updateCartPreview(data);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        try {
          const payload = JSON.parse(settings.data);
      
          if (
            settings.url.includes('/api/front/cart/items/?version=2') &&
            settings.type === 'POST' &&
            xhr.responseJSON &&
            Array.isArray(xhr.responseJSON.result)
          ) {
            reloadCartPreview();
          }
        } catch (e) {
          console.warn('Erro ao interpretar payload do AJAX:', e);
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

document.addEventListener("DOMContentLoaded", function () {

  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
  if(containerShoppub) {
    const pageAboutMe = document.querySelector('#dynamic-page-extra .dinmaic-about-me');
    const aboutUs = document.querySelector('#dynamic-page-extra .about-us');
    if (pageAboutMe || aboutUs) {
      containerShoppub.classList.add('page-front');
    }
  }

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
        var $el = $(el); // Mantendo jQuery para verificar visibilidade
        if ($el.visible(true)) {
            $el.addClass("widget-loaded");
            $el.children().trigger("mouseenter");

            setTimeout(() => {
                const domEl = el; // Converter para elemento DOM nativo
                const appendBtn = domEl.querySelector('#append-btn');
                const btnBuy = domEl.querySelector('.action-control');

                if (appendBtn && btnBuy) {
                  appendBtn.appendChild(btnBuy);
                }
            }, 1000);
        }
    });
  }

  $(window).on('scroll mousemove touchstart', function () {
    loadWidgets();
  });

  const overlay = document.querySelector('.header__product-item--options-overlay');
  const options = document.querySelector('.header__product-item--options');
  
  // Função para adicionar os eventos de clique aos botões de compra
  function addBuyButtonEvent() {
    const allProducts = document.querySelectorAll('.product-item');
  
    allProducts.forEach(element => {
      const button = element.querySelector('.buybox');
      const optionsElement = element.querySelector('.product-item__options');
      
      if (button && optionsElement) {
        button.addEventListener('click', () => {
          options.innerHTML = ''; // Limpa opções anteriores
          options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement para evitar conflito
          overlay.classList.add('active');
          options.classList.add('active');
          b2bItens(); // Chama a função para configurar eventos nas opções
        });
      }
    });
  }
  
  // Usando delegação de eventos no contêiner pai dos produtos
  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.buybox');
  
    if (button) {
      const element = button.closest('.product-item');
      const optionsElement = element.querySelector('.product-item__options');
  
      if (optionsElement) {
        options.innerHTML = ''; // Limpa opções anteriores
        options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement
        overlay.classList.add('active');
        options.classList.add('active');
        b2bItens(); // Chama a função para configurar eventos nas opções
      }
    }
  });
  
  // Lógica para fechar o overlay ao clicar no overlay
  if (overlay) {
    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
      options.classList.remove('active');
      options.innerHTML = ''; // Limpa opções ao fechar
    });
  }
  
  // Chame a função uma vez para os produtos já existentes
  addBuyButtonEvent();
  
  
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });

  waitForElementToExist('#carrousel-comunicado').then(element => {
    const comunicado = document.querySelector('.comunicado');
    if (comunicado) {
      $('#carrousel-comunicado').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        speed: 2000,
        responsive: [
          {
            breakpoint: 991,
            settings: "unslick"
          },
        ]
      });
    }
  });


  const aboutThemes = document.querySelector('.about-themes');
  if (aboutThemes) {
    $('#carrousel-second-section').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

  waitForElementToExist('.rotation-banners').then(element => {
    let rotationVitrine = document.querySelector('.rotation-banners');
    if (rotationVitrine) {
      let rotationNames = rotationVitrine.querySelectorAll('.rotation-banners__title a');
      let initVitrine = rotationVitrine.querySelectorAll('.rotation-banners__list .item');
      initVitrine = Array.from(initVitrine);
  
      if (rotationVitrine && rotationNames.length && initVitrine.length) {
        initVitrine[0].classList.add('active');
        rotationNames[0].classList.add('active');
  
        function activeTab(index) {
          initVitrine.forEach((content) => {
            content.classList.remove('active');
          });
          rotationNames.forEach((content) => {
            content.classList.remove('active');
          });
          initVitrine[index].classList.add('active');
          rotationNames[index].classList.add('active');
  
          $('.banner-masculino__list').slick('refresh');
          $('.banner-feminino__list').slick('refresh');
        }
  
        rotationNames.forEach((itemMenu, index) => {
          itemMenu.addEventListener('click', (e) => {
            e.preventDefault();
            activeTab(index);
          });
        })
      }
    }  

    $('.banner-masculino__list').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        }
      ]
    })

    $('.banner-feminino__list').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        }
      ]
    })
  });


  $("body").on("click", '.product-item__qtd__minus', function (event) {
    event.preventDefault();
    var $input = $(this).closest('.product-item__qtd').find('.product-item__qtd__text');
    var qtd = parseInt($input.val(), 10);

    if (qtd > 1) {
      qtd--;
      $input.val(qtd).attr('value', qtd);
    }
  });

  $("body").on("click", '.product-item__qtd__plus', function (event) {
    event.preventDefault();
    var $input = $(this).closest('.product-item__qtd').find('.product-item__qtd__text');
    var qtd = parseInt($input.val(), 10);

    qtd++;
    $input.val(qtd).attr('value', qtd);
  });

  $("body").on("click", '.not-available-grid', function (event) {
    event.preventDefault();
    var $input = $(this);
    let payload = [];
    payload.push({
      product: $input.attr('data-id'),
      quantity: 1,
      replace_quantity: true,
      is_buying_by_measure: false
    });

    if (payload.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/api/front/cart/items/?version=2',
        data: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).fail(function (jqXHR, textStatus, errorThrown) {
        var data = jqXHR.responseJSON;
        for (var i in data) {
          if ('unavailable' in data[i]) {
            var d = data[i].unavailable;
            Swal.fire({
                imageUrl: d.product.image,
                html: '<strong>' + d.product.name + '</strong>' +
                    '<p>' + d.message + '</p>',
                input: 'text',
                inputPlaceholder: 'Informe seu e-mail:',
                showCancelButton: true,
                confirmButtonText: 'Cadastrar aviso',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: function (email) {
                    return new Promise(function (resolve, reject) {
                        product_detail_service.notify('', email, {}, d.product.id);
                        resolve();
                    });
                }
            });
          }
        };
      });
    }
  });

  function b2bItens() {
    // Função para converter uma string de moeda brasileira para número
    function parseBrazilianCurrency(value) {
      // Remove os pontos de milhar e substitui a vírgula decimal por um ponto
      value = value.replace(/\./g, '').replace(',', '.');
      // Converte para número float
      return parseFloat(value);
    }

    // Armazena o valor anterior dos inputs para calcular a diferença
    let previousValues = {};

    // Função genérica para aplicar a lógica em um contêiner específico
    function applyLogicToContainer(containerSelector) {
      // Aplica a lógica aos elementos dentro do contêiner
      const $container = $(containerSelector);

      if (!$container.find('.product-radio-variation.b2b').length) {
        addToCart($container);
        return;
      }

      $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
        // Inicializa o valor anterior no carregamento da página
        previousValues[$(this).attr('id')] = parseBrazilianCurrency($(this).attr('data-price')) * Number($(this).val());
      });

      $container.find('input[id^="product_item_variation__product_detail_"]').on('change', function () {
        var $el = $(this);

        // Obtém o ID do input
        const inputId = $el.attr('id');

        // Obtém o preço da variação do atributo data-price
        const variationPrice = parseBrazilianCurrency($el.attr('data-price'));

        // Obtém a quantidade da variação
        const variationQtd = Number($el.val());

        // Calcula o valor atual baseado no preço e na quantidade
        const currentValue = variationPrice * variationQtd;

        // Obtém o preço total atual e o converte para número
        const totalValue = parseBrazilianCurrency($container.find('.price-table').attr('data-price'));

        // Calcula a diferença entre o valor atual e o valor anterior
        const previousValue = previousValues[inputId] || 0;
        const difference = currentValue - previousValue;

        // Atualiza o valor total
        const newValue = totalValue + difference;

        // Atualiza o atributo data-price com o novo valor total
        $container.find('.price-table').attr('data-price', newValue.toFixed(2).replace('.', ','));

        // Atualiza o valor anterior para o próximo cálculo
        previousValues[inputId] = currentValue;
      });

      // Lógica para adicionar ao carrinho
      addToCart($container);

    }

    function addToCart(containerSelector) {
      const $container = $(containerSelector);
      $container.find('.b2b-button').click(function () {
        let payload = [];
        let isB2b = false;
        if ($container.find('.product-radio-variation').hasClass('b2b')) {
          isB2b = true;
          $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
            let $el = $(this);
            let value = Number($el.val());
            if (value > 0) {
              payload.push({
                as_free: false,
                product: Number($el.attr('data-id')),
                quantity: value,
                replace_quantity: true,
              });
            }
          });
        }else {
          let $el = $($container).find('input[id^="product_item_variation__product_detail_"]:checked');
          let value = Number($($container).find('.product-item__qtd input').val());
          if (value > 0) {
            payload.push({
              product: Number($el.attr('data-id')),
              quantity: value,
              replace_quantity: true,
              is_buying_by_measure: false
            });
          }
        }

        if (payload.length > 0) {
          let url;
          if(isB2b) {
            url = '/api/front/cart/items/?version=2&add_grid_by_conf=1';
          }else {
            url = '/api/front/cart/items/?version=2';
          }
          $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json'
          }).done(function (data, textStatus, jqXHR) {
            if ($container.hasClass('product-detail__header--infoArea')) {
              if (conf_detalhe_produto_exibir_modal_continuar_comprando) {
                cart_preview.renderCartPreview();
                $("a.js-keeping-buying").fancybox().trigger('click');
              } else {
                location = url_carrinho;
              }
            } else {
              const overlay = document.querySelector('.header__product-item--options-overlay');
              const options = document.querySelector('.header__product-item--options');

              if (overlay && options) {
                overlay.classList.remove('active');
                options.classList.remove('active');
                options.innerHTML = '';
              }
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            handleAjaxFail(jqXHR.responseJSON);
          });
        } else {
          alert('Por favor, selecione a quantidade.');
        }
      });
    }

    // Função para tratar falhas no AJAX
    function handleAjaxFail(data) {
      data.forEach(function (item) {
        if (item.stock) {
          alert(`O produto <strong>"${item.stock.product.name}"</strong> possui <strong>${item.stock.quantity}</strong> unidade(s) em estoque.`);
          return false;
        }

        if (item.limit_itens) {
          alert(item.limit_itens.message);
          return false;
        }

        if (item.buy_rules) {
          showBuyRulesWarning(item.buy_rules);
          return false;
        }
      });
    }

    // Função para exibir regras de compra
    function showBuyRulesWarning(buyRules) {
      let warning = `
      Quantidade solicitada para esta grade: <strong>${buyRules.quantity_total_grid_on_cart}</strong><br><br>
      Para o produto <strong>${buyRules.products[0].product_parent_or_self.name}</strong> é necessário comprar a grade conforme as regras abaixo:<br><br>
      <table class="behaviour-grid__table">
          <thead>
              <tr>
                  <th><strong>Total por grade</strong></th>
                  <th><strong>Total mínimo</strong></th>
                  <th><strong>Mínimo por variação</strong></th>
              </tr>
          </thead>
          <tbody>
  `;

      buyRules.grade_rules.forEach(function (rule) {
        let isCurrentRule = parseInt(buyRules.quantity_total_grid_on_cart) === parseInt(rule.total_quantity_that_must_be_purchased_in_the_grid);
        warning += `
          <tr${isCurrentRule ? ' style="color:red; text-decoration: underline;"' : ''}>
              <td>${formatRuleQuantity(rule.total_quantity_that_must_be_purchased_in_the_grid, rule.total_quantity_must_be_multiple_of_itself)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_in_the_grid)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_by_product, rule.minimum_amount_must_be_multiple_of_itself, rule)}</td>
          </tr>
      `;
      });

      warning += '</tbody></table>';
      alert(warning);
    }

    // Formatação das quantidades de regras
    function formatRuleQuantity(quantity, isMultiple = false, rule = null) {
      if (!quantity) return 'sem limite';
      let formatted = isMultiple ? `múltiplo de ${quantity}` : `${quantity}`;
      if (rule) {
        if (!rule.close_grid) formatted += ' (grade aberta)';
        else formatted += ` (grade fechada${rule.variations_not_required ? ` (não obrigatório: ${rule.variations_not_required.split(",").join(", ")})` : ''})`;
      }
      return formatted;
    }

    // Executa a função para os dois contextos diferentes
    applyLogicToContainer('.product-detail__header--infoArea');
    applyLogicToContainer('.header__product-item--options');

  }

  b2bItens();

  function selectVariation(id, parent) {
    axios.get(`/api/front/product/${id}/get-linked-product/`).then(res => {
      const isProductItem = parent.classList.contains('product-item') ? true : false;
      let productName = '';
      let radioVariations = '';
      let getBody = '';

      //seleciona os elementos a serem alterados
      if (isProductItem) {
        productName = parent.querySelector('.product-item__content--figcaption-name');
        radioVariations = parent.querySelector(".qtd-variations .product-radio-variation");
        getBody = parent.firstElementChild;
      } else {
        productName = parent.querySelector('#js-product_name__product_detail_');
        radioVariations = parent.querySelector(".product-detail__header--infoArea-kit .qtd-variations .product-radio-variation");
        getBody = document.querySelector('body');
      }

      const linkName = "/produto/" + res.data.slug;

      //troca o nome do produto
      if (productName) {
        productName.innerHTML = res.data.name
        if (productName.tagName.toLowerCase() === 'a') {
          //substitui o link href da tag a (ainda experimental pois há variaveis, nao funciona sempre)
          productName.href = linkName;
        }
      }

      if (res.data.variations.length > 0) {
        $(radioVariations).html('');
        if (radioVariations && !isProductItem) {
          $(radioVariations).append('<p class="label_attributes"> escolha o tamanho </p>');
        }
        res.data.variations.forEach(function (variation) {
          const radioInput = $(`<input type="radio" name="product_item_variation__product_detail__${res.data.id}" id="product_item_variation__product_detail__${variation.id}" value="${variation.id}" data-id-auto data-variation-name="${variation.main_attribute.name}" data-origin-location="product_detail">`);

          const radioLabel = $(`<label for="product_item_variation__product_detail__${variation.id}" class="label_radio ${!variation.available ? "out-of-stock" : ""} radio"><span>${variation.main_attribute.value}</span></label>`);

          radioLabel.on('click', function () {
            getBody.setAttribute('data-id-current', variation.id)
          });

          $(radioVariations).append(radioInput).append(radioLabel);
        })
      }

      if (isProductItem) {
        let figure = parent.querySelector('.js_product_detail_list_widget_all_images_image');
        if (figure) {
          // Remove todos os slides atuais
          figure.slick('slickRemove', null, null, true);
          for (const image of res.data.images) {
            figure.slick('slickAdd', `
                <li class="product-item__images-list__item" style="width: 100%; display: inline-block;">
                    <img src="${image}" class="js_product_detail_list_widget_all_images_image product-item__images-list__image" alt="${res.data.name}">
                </li>
            `);
          }
        }else {
          figure = parent.querySelector('.product-item__content .product-item__content--figure a');
  
          if (figure) { // Verifique se figure não é null
            figure.href = linkName;
            figure.innerHTML = ''; // Limpa o conteúdo existente
            if (res.data.images.length > 0) {
              figure.innerHTML = `<img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span>`;
            }
          }
        }
      } else {
        const keepBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
        const keepBuyingImage = document.querySelector('.keeping-buying__figure--image');

        if (keepBuyingName && keepBuyingImage) {
          keepBuyingName.innerHTML = res.data.name;
          keepBuyingImage.setAttribute('src', `${res.data.images[0]}`);
        }

        $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
        $('.product-detail__header--photoArea-photo ul').html('');
        $('.product-detail__header--photoArea-thumbs-default ul').html('');
        if (res.data.images.length > 0) {
          res.data.images.forEach(function (image, index) {
            $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%;"><a href="${image}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-photo ul').append(`<li class="sp-wrap" id="photo-${index}"><a href="${image}" data-fancybox="gallery1"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-thumbs-default ul').append(`<li class="sp-wrap" id="photo-${index}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></li>`);
          });
        }
      }

      if (getBody) {
        getBody.setAttribute('data-id', `${id}`);
        getBody.setAttribute('data-id-current', `${id}`);
      }
    }).catch(err => { console.log(err); });
  }

  document.body.addEventListener('click', function (event) {
    const target = event.target;
    
    // Verifica se o target ou qualquer elemento pai contém as classes de cores
    const colorElement = target.closest('.product__colors-item, .product__colors-box, .product__colors-image');
    
    if (colorElement) {
      const isProductItem = colorElement.closest('.product-item');
      const isModalPopup = colorElement.closest('.shoppub-fast-buy-popup');
      const isInfoAreaVariation = colorElement.closest('.product-detail__header--infoArea-variation');
  
      // SE tiver link pai, previne o redirect APENAS se NÃO estiver dentro de .product-detail__header--infoArea-variation
      const linkParent = colorElement.closest('a');
      if (linkParent && !isInfoAreaVariation) {
        event.preventDefault();
        event.stopPropagation();
      }
  
      if (isProductItem) {
        const productItem = colorElement.closest('.product-item') || colorElement.closest('.product-detail__header');
        const targetColor = colorElement.classList.contains('product__colors-item') ? colorElement : colorElement.closest('.product__colors-item');
  
        const colorsContainer = productItem.querySelector('div.product__colors');
        const options = colorsContainer.querySelectorAll('.product__colors-item');
        options.forEach(option => option.classList.remove('is-selected'));
  
        targetColor.classList.add('is-selected');
        const selected = targetColor.getAttribute('variation-id');
        selectVariation(selected, productItem);
  
      } else if (isModalPopup) {
        const productItem = colorElement.closest('.shoppub-fast-buy-popup');
        const targetColor = colorElement.classList.contains('product__colors-item') ? colorElement : colorElement.closest('.product__colors-item');
        const selected = targetColor.getAttribute('variation-id');
        selectVariation(selected, productItem);
      }
    }
  });
  

});

const pageExtraCarrosel = document.querySelector('#dynamic-page-extra .image-list');
if (pageExtraCarrosel) {
  $('#dynamic-page-extra .image-list').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
}

